const processInclude = require('base/util');

$(() => {
  processInclude(require('base/orderHistory/orderHistory'));
  processInclude(require('./addressBook/addressBook'));
});
